var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 17,
    viewBox: "0 0 72 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_2302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9305 0.411133H31.5494V16.2219H33.9305V0.411133Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5499 16.222V13.7895H31.5494V16.222H41.5499Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3824 2.23544H20.4773V9.2895H27.3824V2.23544Z",
    fill: "#00C98F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6915 2.23544H15.4771V9.2895H18.6915V2.23544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3824 11.1138H20.4773V14.3976H27.3824V11.1138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6915 11.1138H15.4771V14.3976H18.6915V11.1138Z",
    fill: "#406AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4773 1.14087H18.6915V14.3976H20.4773V1.14087Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.477 0.411133H13.6912V16.2219H15.477V0.411133Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1683 0.411133H27.3824V16.2219H29.1683V0.411133Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0492 9.28952H13.8103V11.1138H29.0492V9.28952Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8111 0.411133H14.6437V2.23546H28.8111V0.411133Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.454 14.3976H14.6437V16.2219H28.454V14.3976Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.193 16.2219H43.2167L48.6803 0.411133H52.151L57.6222 16.2219H54.6459L50.4762 3.69492H50.3599L46.193 16.2219ZM46.316 9.89762H54.5002V12.3301H46.316V9.89762Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5271 16.2219V0.411133H62.2653V7.70843H62.5035L68.3371 0.411133H71.7454L65.837 7.47263L71.7897 16.2219H68.4562L63.9321 9.4173L62.2653 11.4787V16.2219H59.5271Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81662e-06 16.2219V14.4091L7.81293 2.84552H0L1.81662e-06 0.411133H11.3101V2.14045L3.45257 13.7895H11.3101V16.2219H1.81662e-06Z",
    fill: "#272D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_2302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.7897,
    height: 15.8108,
    fill: "white",
    transform: "translate(0 0.411133)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ece006dc40ae470f73a488e451d058e.svg";
export { ForwardRef as ReactComponent };